import { useEffect, useState } from "react";
import { ClientFile } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken } from "../../../slices/staffSlice";
import { show } from "../../../slices/toastSlice";
import { fetchRequests } from "../../../Requests/getRequests";
import { authStaff } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";

function ClientFiles({ name, loan }) {

    const files = loan?.files;
    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        let unsubscribe = false;

        const getPhotos = async () => {
            let res = await fetchRequests(`/loans/staff/getClientPhotos`, "GET", authStaff(accessToken), { phone: loan?.phone }, {});

            if (res?.code === 401) {
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
                return;
            }
            if (res?.err) {
                dispatch(show({ type: "error", state: true, message: res?.err }));
                return;
            }
            if (!unsubscribe) setPhotos(res);
        };

        if (name === "Client") getPhotos();

        return () => { unsubscribe = true; };
    }, [name, accessToken, dispatch, navigate, loan]);

    const items = name === "Client" ? photos : files;

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
            <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">{name} Files</h4>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60">
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Type of File</th>
                            <th scope="col" className="px-5 py-3 text-right text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                        {items && items.length > 0 ?
                            items.map((file, index) => (
                                <ClientFile
                                    key={index}
                                    loanId={loan?.loanId}
                                    file={file}
                                    phone={loan?.phone}
                                    name={name}
                                />
                            ))
                        :
                            <tr>
                                <td colSpan={2} className="px-5 py-10 text-center text-sm text-gray-400">
                                    No files found.
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ClientFiles;
